import {Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {Observable} from 'rxjs';
import {map, startWith, tap} from 'rxjs/operators';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
export interface Option {
  id: number;
  name: string;
}

@Component({
  selector: 'app-checkbox-dynamic',
  templateUrl: './checkbox-dynamic.component.html',
  styleUrls: ['./checkbox-dynamic.component.css']
})
export class CheckboxDynamicComponent implements OnInit {
  myControl = new FormControl();

  formGroup: FormGroup;
  @Output() selectChange: EventEmitter<Option>;
   @Input() isChecked: boolean = false;
   @Input() valueid: any = 666;


 
  public nameFC: any = '';

  constructor(private fb: FormBuilder) {
   
  }

  ngOnInit() {
     this.selectChange = new EventEmitter;
    this.nameFC ="formG"+this.valueid;
    console.log("this.valueid => ", this.valueid);
     this.formGroup = this.fb.group({
      myCheckbox: [this.isChecked]  // Checkbox will start as checked
    });
 
  }

}